<template>
  <!-- -->
  <div class="table-data-3-show">
    <div class="left">
      <alone-image :src="imageList[0].itemImage" class="table-image"/>
      <alone-text-on-image :data="imageList[0]"/>
    </div>
    <div class="right">
      <div class="r-top">
        <alone-image :src="imageList[1].itemImage" class="table-image"/>
        <alone-text-on-image :data="imageList[1]"/>
      </div>
      <div class="r-bottom">
        <alone-image :src="imageList[2].itemImage" class="table-image"/>
        <alone-text-on-image :data="imageList[2]"/>
      </div>
    </div>
  </div>
</template>

<script>

import YqIcon from "@/components/YqIcon.vue";
import AloneImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneImage.vue";
import {watch} from "vue";
import AloneTextOnImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneTextOnImage.vue";
export default {
  props: {
    data: {
      default: () => {
        return {}
      }
    },
  },
  name: "",
  components: {
    YqIcon, AloneTextOnImage, AloneImage
  },
  data() {
    return {
      imageList: [],
    };
  },
  created() {
    this.init();
    watch(() => this.data, () => this.init())
  },
  methods: {
    init() {
      if (!this.data.componentData || !this.data.componentData.length) {
        this.imageList = [
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: ""},
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: ""},
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: ""},
        ];
      } else {
        this.imageList = this.data.componentData;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table-data-3-show {
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  background-color: #FFF;
  border-radius: 10px;
  .left{
    width: 315px;
    height: 250px;
    position: relative;
  }
  .right{
    width: 315px;
    height: 250px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .r-top{
      width: 100%;
      height: 115px;
      position: relative;
    }
    .r-bottom{
      width: 100%;
      height: 115px;
      position: relative;
    }
  }
}
</style>